/**
 * Echo suppression for server-applied changes.
 *
 * When applying changes received from the server, wrap the writes in
 * applyServerChange() to suppress sync event creation. This prevents
 * the client from pushing the same changes back to the server.
 */

let _applyingServerChanges = false

export function isApplyingServerChanges(): boolean {
  return _applyingServerChanges
}

export async function applyServerChange<T>(fn: () => Promise<T>): Promise<T> {
  _applyingServerChanges = true
  try {
    return await fn()
  } finally {
    _applyingServerChanges = false
  }
}
